<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let value = 0
    export let type = 'text'
    export let label = ''
    export let placeholder = ''
    export let errormessage = 'Error';
    export let disabled = false;
    export let width = '160px'
    export let height = '24px'
    export let style = ''
    export let labelStyle = ''
    export let inputStyle = ''
    export let errorStyle = ''
    export let prefix = ''
    export let suffix = ''
    export let validate = () => {return true;}
    export let regex = ""
    export let cadDisabled = false; // DO NOT USE! THIS IS COSTYL

    // let error = "";

    function checkRgx(e) {
        if (regex != "") {
            const regexxx = new RegExp(regex);
            if (!regexxx.test(e)) {
                console.log(e)
                value = value.replace(e, '')
            }
        }
    }
</script>

<div on:click style={style} class={$$props.class}>
    <label class="b2" style={labelStyle}>{label}</label>
    <div class="myinput {!validate(value) ? 'error' : ''}" style="width: fit-content; height: fit-content">
        {#if prefix}
            <span class="prefix">{prefix}</span>
        {/if}
        <input class="b2 {disabled ? 'disabled' : ''} {cadDisabled ? 'cadDisabled' : ''} "
               style="height: {height}; width: {width}; {inputStyle}; margin: 0;"
               bind:value={value}
               on:input={(e) => {dispatch('input'); checkRgx(e.data)}}
               placeholder={placeholder}
               type='text'
               disabled={disabled || cadDisabled}>
        {#if suffix}
            <span class="suffix">{suffix}</span>
        {/if}
    </div>
    {#if !validate(value)}
        <div class="error-text" style={errorStyle}>{errormessage}</div>
    {/if}
</div>

<style>
    .prefix{
        width: fit-content;
        margin-left: 8px;
        font-family: 'Source Sans Pro';
        color: #B2B6CC;
    }

    .suffix{
        width: fit-content;
        margin-right: 8px;
        font-family: 'Source Sans Pro';
        color: #B2B6CC;
    }

    input{
        outline: none !important;
        border: none;
        background-color: transparent;
    }

    .myinput {
        outline: none !important;
        border: 1px solid #F2F4F7;
        border-radius: 5px;
        color: #3A3B45;
    }

    .myinput:focus {
        border: 1px solid #0043A4;
        pointer-events: none;
    }

    .myinput:hover{
        border: 1px solid #CCD9ED;
    }
    .disabled {
        border: 1px solid #F2F4F7;
        background-color: #F2F4F7;
    }
    .disabled:hover {
        border: 1px solid #F2F4F7;
    }

    .error-text {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 400;
        font-size: 8px;
        line-height: 10px;
        color: #F44336;
    }

    .error {
        border: 1px solid #F44336;
    }

    .error:hover {
        border: 1px solid #F44336;
    }

    .cadDisabled {
        color: #3A3B45;
    }

    .cadDisabled:hover {
        cursor: pointer;
    }
</style>

<!--<script>-->
<!--    import { createEventDispatcher } from 'svelte';-->

<!--    const dispatch = createEventDispatcher();-->

<!--    export let value = 0-->
<!--    export let type = 'text'-->
<!--    export let label = ''-->
<!--    export let placeholder = ''-->
<!--    export let errormessage = '';-->
<!--    export let disabled = false;-->
<!--    export let width = '160px'-->
<!--    export let height = '24px'-->
<!--    export let style = ''-->
<!--    export let labelStyle = ''-->
<!--    export let inputStyle = ''-->
<!--    export let errorStyle = ''-->

<!--    let error = "";-->

<!--    export const validate = (event) => {-->
<!--        // todo validate-->
<!--    }-->
<!--</script>-->

<!--<div on:click style={style}>-->
<!--    <label class="b2" style="color: {(value) ? '#0043A4': '#3A3B45'}; {labelStyle}">{label}</label>-->
<!--    <input class="b2 {disabled ? 'disabled' : ''}" bind:value={value} on:input={()=>dispatch('input')}-->
<!--           placeholder={placeholder} on:blur={()=>{validate(); dispatch("blur")}} type="text"-->
<!--           style="height: {height}; width: {width}; {inputStyle}; margin: 0" disabled={disabled}>-->
<!--    <div class="error" style={errorStyle}>{error}</div>-->
<!--</div>-->

<!--<style>-->
<!--    input {-->
<!--        outline: none !important;-->
<!--        border: 1px solid #F2F4F7;-->
<!--        border-radius: 5px;-->
<!--        color: #3A3B45;-->
<!--    }-->

<!--    input:focus {-->
<!--        border: 1px solid #0043A4;-->
<!--        pointer-events: none;-->
<!--    }-->

<!--    input:hover{-->
<!--        border: 1px solid #CCD9ED;-->
<!--    }-->

<!--    .disabled {-->
<!--        border: 1px solid #F2F4F7;-->
<!--        background-color: #F2F4F7;-->
<!--    }-->
<!--    .disabled:hover {-->
<!--        border: 1px solid #F2F4F7;-->
<!--    }-->
<!--</style>-->